interface IIndexableByStringOrSymbol extends Object {
    [ key: string | symbol ]: any
}

export function deepFreeze< T extends IIndexableByStringOrSymbol >( item: T ): Readonly< T > {
    // Retrieve the property names defined on object
    const propNames: ( string | symbol )[] = Reflect.ownKeys( item );

    // Freeze properties before freezing self
    for ( const name of propNames ) {
        const value = item[ name ];

        if ( ( value && typeof value === "object" ) || typeof value === "function" ) {
            deepFreeze( value );
        }
    }

    return Object.freeze< T >( item );
}